enum PrivacyFilter {
  ALL = 'all',
  PRIVATE = 'private',
  PUBLIC = 'public',
}

export default PrivacyFilter